import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 24px;
  height: 24px;
`

export const ResendEmailIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M18.35 19.9L17.3 18.85L19.125 17H14.6V15.5H19.125L17.3 13.65L18.35 12.6L22 16.25L18.35 19.9ZM3.5 17C3.0875 17 2.73438 16.8531 2.44063 16.5594C2.14688 16.2656 2 15.9125 2 15.5V4.5C2 4.0875 2.14688 3.73437 2.44063 3.44062C2.73438 3.14687 3.0875 3 3.5 3H17.5C17.9125 3 18.2656 3.14687 18.5594 3.44062C18.8531 3.73437 19 4.0875 19 4.5V10.3C18.875 10.2833 18.75 10.2708 18.625 10.2625C18.5 10.2542 18.375 10.25 18.25 10.25C18.1167 10.25 17.9917 10.2542 17.875 10.2625C17.7583 10.2708 17.6333 10.2833 17.5 10.3V5.675L10.4 10.7L3.5 5.7V15.5H12.275C12.2583 15.6333 12.25 15.7458 12.25 15.8375V16.1812C12.25 16.3187 12.2542 16.4562 12.2625 16.5937C12.2708 16.7312 12.2917 16.8667 12.325 17H3.5ZM4.4 4.5L10.4 8.85L16.55 4.5H4.4Z" />
    </Svg>
  )
}
